module.exports = __webpack_public_path__ + "static/media/Principal Skinner.33ce81bf.png";